import { render, staticRenderFns } from "./RealValueWue.vue?vue&type=template&id=147cd122&scoped=true&"
import script from "./RealValueWue.vue?vue&type=script&lang=js&"
export * from "./RealValueWue.vue?vue&type=script&lang=js&"
import style0 from "./RealValueWue.vue?vue&type=style&index=0&id=147cd122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147cd122",
  null
  
)

export default component.exports